import React, { Component } from 'react';

class IconDropbox extends Component {
  render() {
    return (

      <div class="icon icon-dropbox">

      <svg viewBox="0 0 52 50" xmlns="http://www.w3.org/2000/svg" xmlnsSerif="http://www.serif.com/"
      fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
          <g id="icon-dropbox" fill="#1587ea">
              <path id="Shape" d="M23.907 28.181l-13.205-8.532a1.182 1.182 0 0 0-1.383.073L.442 26.88a1.187 1.187 0 0 0 .1 1.92l13.205 8.532c.428.277.986.248 1.383-.072l8.878-7.158a1.188 1.188 0 0 0-.101-1.921z"
              />
              <path id="Shape1" serifId="Shape" d="M27.444 30.102l8.878 7.158c.397.32.955.349 1.383.072L50.91 28.8a1.187 1.187 0 0 0 .1-1.92l-8.877-7.158a1.183 1.183 0 0 0-1.384-.073l-13.204 8.532a1.188 1.188 0 0 0-.101 1.921z"
              />
              <path id="Shape2" serifId="Shape" d="M24.008 7.42L15.13.262a1.182 1.182 0 0 0-1.383-.073L.542 8.721a1.188 1.188 0 0 0-.1 1.921L9.319 17.8c.397.32.955.349 1.383.072L23.907 9.34a1.187 1.187 0 0 0 .101-1.92z"
              />
              <path id="Shape3" serifId="Shape" d="M50.91 8.721L37.705.189a1.182 1.182 0 0 0-1.383.073L27.444 7.42a1.187 1.187 0 0 0 .101 1.92l13.205 8.532c.428.277.986.248 1.383-.072l8.877-7.158a1.188 1.188 0 0 0-.1-1.921z"
              />
              <path id="Shape4" serifId="Shape" d="M25.346 31.622l-9.942 7.946c-.36.288-.864.313-1.251.063l-2.45-1.583a1.073 1.073 0 0 0-1.655.904v.856c0 .376.196.725.517.919l14.801 8.99c.342.208.77.208 1.113 0l14.801-8.99c.32-.194.517-.543.517-.919v-.764c0-.852-.941-1.366-1.656-.904l-2.306 1.49a1.072 1.072 0 0 1-1.253-.064l-9.895-7.943a1.072 1.072 0 0 0-1.341-.001z"
              />
          </g>
      </svg>

      </div>

    );
  }
}

export default IconDropbox;



// WEBPACK FOOTER //
// ./src/assets/components/icons/iconDropbox.js